module.exports = __webpack_public_path__ + "static/media/user-api-home.4c8a3714.png";